const faqItems = [
  {
    q: '91影视看片下载需要付费或注册会员吗？',
    a: '完全不需要！91影视看片下载作为免费影视大全平台，所有电影、电视剧、综艺、动漫资源均免费在线观看，无需注册、无需付费、无需会员，打开浏览器即可享受高清追剧体验。',
  },
  {
    q: '天美麻花星空影视的内容在哪里可以看？',
    a: '天美麻花星空影视免费观看内容已完整接入91影视看片下载，您可以在平台的天美麻花专区直接观看。麻花星空影视免费观看用户无需额外操作，所有独家内容与本平台同步更新，高清画质流畅播放。',
  },
  {
    q: '播放视频时遇到卡顿或缓冲该怎么办？',
    a: '91影视看片下载配备多线路智能切换系统。如果您在观看高清免费影视时遇到卡顿，页面会自动为您切换最优线路。您也可以手动点击播放器上的线路切换按钮选择其他播放源，确保流畅观影体验。',
  },
  {
    q: '如何快速找到我想看的影片？',
    a: '您可以通过首页的话题标签区按类型浏览，也可以在影视索引中按电影、电视剧、综艺、动漫等大类快速定位。如果您有具体目标，页面顶部的搜索框可以帮您精准找到想看的免费电影或电视剧。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-3 whitespace-nowrap">
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            常见问题解答
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            关于91影视看片下载的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="grid grid-cols-1 gap-4">
            {faqItems.map((item, idx) => (
              <div key={idx} className="bg-background-50 rounded-xl p-5 md:p-6">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-3 flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center mt-0.5">
                    <span className="text-primary-600 text-xs font-bold">Q</span>
                  </span>
                  {item.q}
                </h3>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed pl-9">
                  {item.a}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}